<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1">
              <img v-else :src="bgimg2">
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div style="width: 100%; height: 4.8125rem"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 线上报修 -->
      <div class="repair">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>线上报修</span>
          <img src="../assets/zszs2.png" />
        </div>
        <div class="note">
          <p>
            感谢您浏览采航(上海)貿易有限公司官网，我们十分重视您的意见和咨询
          </p>
          <p>
            如果您对采航(上海)貿易有限公司产品相关报修服务，请填写如下表单，我们将尽快与您取得联系。
          </p>
        </div>
        <form class="formbox container" @submit.prevent="submit">
          <div class="form-group flexStart formGroup2">
            <label>公司名称*</label>
            <input type="text" class="form-control" v-model="company" />
          </div>
          <div class="form-row" style="margin: 0">
            <div class="form-group col-md-4 flexStart formGroup2">
              <label>联系人*</label>
              <input type="text" class="form-control" v-model="name" />
            </div>
            <div class="form-group col-md-4 flexStart formGroup2">
              <label>联系电话*</label>
              <input
                type="tel"
                class="form-control"
                v-model="telephone"
                maxlength="11"
              />
            </div>
            <div class="form-group col-md-4 flexStart formGroup2">
              <label>邮箱*</label>
              <input type="email" class="form-control" v-model="email" />
            </div>
          </div>
          <div class="form-row" style="margin: 0">
            <div class="form-group col-md-6 flexStart formGroup2">
              <label>产品型号*</label>
              <input type="text" class="form-control" v-model="productId" />
            </div>
            <div class="form-group col-md-6 flexStart formGroup2">
              <label>仪器序号*</label>
              <input type="text" class="form-control" v-model="equipmentId" />
            </div>
          </div>
          <div class="form-group flexStart formGroup2">
            <label>服务内容*：</label>
            <div class="form-row" style="margin: 0">
              <ul class="selectList">
                <li
                  class="selectItem"
                  v-for="(item, index) in selectList"
                  :key="index"
                  @click="doChoose(index)"
                >
                  <img v-if="item.isSelected" src="../assets/xzxz.png" />
                  <img v-else src="../assets/wxz.png" />
                  <span>{{ item.name }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="form-group flexStart formGroup2">
            <label>故障问题描述*</label>
            <textarea class="form-control" rows="10" v-model="desc"></textarea>
          </div>
          <button type="submit" class="repairBtn">
            提交报修
          </button>
        </form>
      </div>

      <!-- 提醒弹窗 -->
      <div class="modal-bg" v-show="isShow4">
        <div class="modal-container">
          <div class="modal-top">
            <p class="modal-title">信息</p>
            <img src="../assets/cancel.png" class="close" @click="hideModal" />
          </div>

          <div class="modal-main">{{ message }}</div>
          <div class="modal-bottom">
            <p class="confirmBtn" @click="hideModal">确定</p>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>

/* 标题 */
.toptitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* line-height: 30px;
      font-size: 31px; */
  line-height: 1.875rem;
  font-size: 1.9375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e2e2e;
  /* margin: 70px 0 50px; */
  margin: 4.375rem 0 3.125rem;
}

.toptitle img {
  /* width: 77px;
      height: 14px; */
  width: 4.8125rem;
  height: 0.875rem;
}

.toptitle span {
  /* margin: 0 21px; */
  margin: 0 1.3125rem;
}

@media screen and (max-width: 1200px) {
  .formbox {
    width: 86% !important;
    max-width: 1140px !important;
  }

  .repairBtn {
    height: 4.5rem !important;
    line-height: 1.6875rem !important;
    font-size: 1.8125rem !important;
    margin: 2.7rem 0 3.1rem !important;
    padding: 0 13% !important;
  }
}

@media screen and (max-width: 700px) {
  .repairBtn {
    height: 4.5rem !important;
    line-height: 1.6875rem !important;
    font-size: 1.8125rem !important;
    margin: 2.4rem 0 2.6rem !important;
    padding: 0 13% !important;
  }
}

@media (max-width: 499px) {
  .note {
    line-height: 1.5rem !important;
    font-size: 0.7rem !important;
    margin-bottom: 2.5rem !important;
    padding: 0 2%;
  }

  .formbox {
    width: 100% !important;
    padding: 0 2% !important;
  }

  .repairBtn {
    height: 3.6rem !important;
    line-height: 1rem !important;
    font-size: 1.2rem !important;
    margin: 1.5rem 0 2.1rem !important;
    padding: 0 13% !important;
  }
}

/* 线上报修 */
.note {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* line-height: 28px;
  font-size: 15px; */
  line-height: 1.75rem;
  font-size: 0.9375rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  color: #333333;
  /* margin-bottom: 49px; */
  margin-bottom: 3.0625rem;
  box-sizing: border-box;
}

/* 表单 */
.form-row {
  margin: 0;
}

.form-row > [class*="col-"]:first-of-type {
  padding-left: 0;
}

.form-row > [class*="col-"]:last-of-type {
  padding-right: 0;
}

.formGroup2 {
  margin-bottom: 1.625rem !important;
}

@media screen and (max-width: 766px) {
  .form-row > [class*="col-"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.form-group > label {
  line-height: 15px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 19px;
}

.form-group > input {
  height: 2.5625rem;
  line-height: 0.875rem !important;
  font-size: 0.8125rem !important;
  font-family: Microsoft YaHei;
  font-weight: 500 !important;
  color: #333333 !important;
  background: #f2f3f5;
  border-radius: 0.3125rem;
  border-color: #f2f3f5;
  box-shadow: none !important;
  outline: none;
}

.form-control:focus {
  background: #f2f3f5 !important;
  border-color: #f2f3f5;
  box-shadow: none !important;
  outline: none;
}

.form-group > textarea {
  line-height: 0.875rem !important;
  font-size: 0.8125rem !important;
  font-family: Microsoft YaHei;
  font-weight: 500 !important;
  color: #333333 !important;
  background: #f2f3f5;
  border-radius: 0.3125rem;
  border-color: #f2f3f5;
  box-shadow: none !important;
  outline: none;
  resize: none;
}

.flexStart {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.selectList {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.selectItem {
  line-height: 0.8125rem;
  font-size: 0.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333;
  margin-right: 1.25rem;
}

.selectItem img {
  width: 1.5rem;
  height: 1.4375rem;
  margin-right: 0.5rem;
}

.selectItem span {
  height: 0.8125rem;
}

.note p {
  margin-bottom: 0;
}

.repairBtn {
  height: 4.6875rem;
  line-height: 1.6875rem;
  font-size: 1.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #020e62;
  border-radius: 0.5rem;
  margin: 2.9375rem 0 3.625rem;
  padding: 0 13%;
}

.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.modal-container {
  width: 17.5rem;
  border-radius: 0.3125rem;
  background: #fff;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.625rem;
  box-sizing: border-box;
}

.modal-top .close {
  width: 0.9375rem;
  height: 0.9375rem;
}

.modal-main {
  text-align: left;
  padding: 1.25rem 2.5rem;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: 1.25rem;
  margin-bottom: 0.9375rem;
  box-sizing: border-box;
}

.confirmBtn {
  line-height: 0.875rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  background: #020e62;
  padding: 0.625rem 1.25rem;
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import { getBackground, requestRepairs } from "../api/interface"; // 引入接口
export default {
  name: "supportView",
  components: {
    bottomFooter,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      company: "",
      name: "",
      telephone: "",
      email: "",
      productId: "",
      equipmentId: "",
      desc: "",
      service: "",
      selectList: [
        {
          name: "维修",
          value: 1,
          isSelected: false,
        },
        {
          name: "校正",
          value: 2,
          isSelected: false,
        },
      ],
      message: "",
      isShow4: false, //是否展示消息弹窗
      isCollapse: true, //是否折叠导航条
      bgimg1: require('../assets/collapse.png'),
      bgimg2: require('../assets/close1.png'),
    };
  },

  created() {
    this.getImg();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;
      console.log("scrollTop", scrollTop);
      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "Technical-support" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    doChoose(idx) {
      console.log(idx);
      let selectList = this.selectList;
      let service = this.service;
      // 点的是同一个
      if (service == idx + 1) {
        service = "";
        selectList[idx].isSelected = !selectList[idx].isSelected;
      } else {
        service = selectList[idx].value;
        selectList[idx].isSelected = !selectList[idx].isSelected;
        if (idx === 0) {
          selectList[1].isSelected = false;
        } else {
          selectList[0].isSelected = false;
        }
      }
      this.$set(this, "service", service);
      this.$set(this, "selectList", selectList);
    },

    // 是否展示消息弹窗
    hideModal() {
      this.$set(this, "isShow4", false);
    },

    // 提交表单
    submit(e) {
      e.preventDefault(); // 阻止默认提交行为
      console.log(
        this.company,
        this.name,
        this.telephone,
        this.email,
        this.productId,
        this.equipmentId,
        this.service,
        this.desc,'================='
      );
      var regMobile = /^1[34578]\d{9}$/; //或者为/^1[3|4|5|7|8][0-9]\d{8}$/;
      var regEmail = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/; //邮箱验证
      if (
        this.company == "" ||
        this.name == "" ||
        this.telephone == "" ||
        this.email == "" ||
        this.productId == "" ||
        this.equipmentId == "" ||
        this.desc == "" ||
        this.service == ""
      ) {
        this.$set(this, "message", "请填写完必填信息！");
        this.$set(this, "isShow4", true);
      } else if (!regMobile.test(this.telephone)) {
        this.$set(this, "message", "手机号格式不正确！");
        this.$set(this, "isShow4", true);
      } else if (!regEmail.test(this.email)) {
        this.$set(this, "message", "邮箱格式不正确！");
        this.$set(this, "isShow4", true);
      } else {
        let params = {
          RE_FIRM_NAME: this.company,
          RE_CONTACTS: this.name,
          RE_PHONE: this.telephone,
          RE_EMAIL: this.email,
          RE_MODEL: this.productId,
          RE_SERIAL: this.equipmentId,
          RE_TYPE: this.service,
          RE_NOTE: this.desc,
        };
        requestRepairs(params).then((res) => {
          console.log(res);
          if (res.state == "success") {
            this.$set(this, "message", "提交信息成功");
            this.$set(this, "isShow4", true);
          }
        });
      }
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
